export default __webpack_public_path__ + "314c09b4aa692687e47f8e63a4378be5.png";